import {Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {ToastService} from "../../services/toast.service";
import {LangService} from "../../services/lang.service";
import {Router} from "@angular/router";
import {ContentService} from "../../services/content.service";
import { Guide } from '../../structure/types/guide.class';

@Component({
    selector: 'app-block-recommended-guides',
    templateUrl: './block-recommended-guides.component.html',
    styleUrls: ['./block-recommended-guides.component.scss'],
    standalone: false
})
export class BlockRecommendedGuidesComponent implements OnInit {
    @Input() guides: Guide[] = [];
    @ViewChild('swiperRecommendedGuides', {static: false}) swiperRecommendedGuides: ElementRef | undefined;
    startingGuideId: any;

    constructor(
        public toastService: ToastService,
        public lang: LangService,
        public router: Router,
        public contentService: ContentService
    ) {
    }

    ngOnInit() {
    }

    /**
     * Swipe Slide
     * 0 - Back / Prev
     * 1 - Next
     * @param type
     */
    swipeSlide(type: number = 0) {
        // @ts-ignore
        const swiperInstance = this.swiperRecommendedGuides.nativeElement.swiper;
        (type === 1) ? swiperInstance.slideNext() : swiperInstance.slidePrev();
    }

    async handleGuideClick(g: Guide) {
        const isNotStarted = !g.status || g.status === 'not_started';
        const commands = ['/guide', g.id];
        const queryParams = g.status === 'completed' ? { retake: 1 } : {};

        try {
            if (isNotStarted) {
                this.startingGuideId = g.id;
                await this.contentService.sendGuideStepResult(0, null, g.id);
            }
            await this.router.navigate(commands, { queryParams });
        } catch (e) {
            console.error('Failed to initialize guide start', e);
            await this.router.navigate(commands, { queryParams });
        } finally {
            this.startingGuideId = null;
        }
    }
}
